import { margin, MarginProps } from 'styled-system';
import styled from '../../../theme/theme';

interface ListDividerProps extends MarginProps {}

export const ListDivider = styled.hr<ListDividerProps>(
  ({ theme }) => ({
    margin: 0,
    border: 0,
    borderTop: `1px solid ${theme.colors.neutral[200]}`,
  }),
  margin,
);
